import React, {useEffect} from "react";
import Picture from "../../../components/common/Picture";
import {ScrollDownIcon} from "../../../components/common/Icons";

export const HeroSection = () => {
    useEffect(() => {
        const handleMouseMove = (event: MouseEvent) => {
            const heroSection = document.getElementById('hero-section');
            if (heroSection) {
                const {clientX, clientY} = event;
                heroSection.style.setProperty('--mouse-x', `${clientX}px`);
                heroSection.style.setProperty('--mouse-y', `${clientY}px`);
            }
        };

        window.addEventListener('mousemove', handleMouseMove);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);

    return (
        <div
            id="hero-section"
            className="snap-section relative h-screen flex items-center bg-royal-pine justify-center text-center overflow-x-clip"
        >
            {/* Glow */}
            <div className="hero-glow"/>

            {/* Main Content */}
            <div
                className="relative z-20 px-4 sm:px-6 lg:px-8 flex flex-col items-center max-w-full sm:max-w-2xl md:max-w-3xl lg:max-w-4xl ">
                {/* Logo */}
                <Picture
                    webpSrc="/images/logo.webp"
                    pngSrc="/images/logo.png"
                    alt="All Aces Club Logo"
                    className="w-3/4 max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl mb-4 sm:mb-6"
                    onErrorSrc={'https://placehold.co/600x300/153D40/C6A375?text=All+Aces+Club'}
                />

                {/* Tagline */}
                <p className="text-base ms:text-lg md:text-xl lg:text-2xl mt-2 sm:mt-4 text-ivory text-opacity-90 font-light tracking-wide px-2">
                    A Member's Only Luxury Club
                </p>
            </div>

            {/* Scroll Indicator */}
            <div className="absolute z-20 bottom-6 sm:bottom-8 lg:bottom-10 animate-bounce">
                <div
                    className="flex flex-col items-center space-y-2 cursor-pointer"
                    onClick={() => {
                        const nextSection = document.querySelector('#club-intro-video-section');
                        if (nextSection) {
                            nextSection.scrollIntoView({behavior: 'smooth'});
                        }
                    }}
                >
                    <span
                        className="text-xs sm:text-sm uppercase tracking-widest text-ivory/80 px-4 text-center leading-tight">
                        Scroll to enter
                    </span>
                    <ScrollDownIcon className="w-6 h-6 sm:w-8 sm:h-8 text-ivory/80"/>
                </div>
            </div>
        </div>
    );
}